export function mapIdNameToOptions(json) {
    return json.map((i) => ({ value: i.id, label: i.name }));
}
